import React from 'react'

// Persistent "+ Add chapter" row at the bottom of the ToC (author tools only)
export const AddChapterRow = ({ onAdd }) => (
  <li className="CourseNavMenuItem toc-add-chapter-row" role="none">
    <button
      type="button"
      role="menuitem"
      className="me-btn me-btn-tree toc-add-chapter-btn"
      onClick={onAdd}
    >
      <i className="fa-regular fa-plus fa-fw" aria-hidden="true" />
      <span className="me-btn-label">Add chapter</span>
    </button>
  </li>
)
